import React from "react";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { IExtractList } from "../../LeftPanel/ExtractList/redux/Types";
import { FormElement, FormSection } from "../../Common/UI/Index";
import "./Style.scss";

interface IProps {
  /**
   * View extract details
   */
  selectedExtract: IExtractList;
}


/**
 * Responsible for rendering the view extract form
 * @param selectedExtract - view extract details
 * @returns - Returns save extract footer page
 */

const ExtractViewPage: React.FC<IProps> = (props: IProps) => {

  const { selectedExtract } = props;
  const { t: translate } = useTranslation();
  const emptyValue = translate("Extract.ExtractStatus.Empty");
  const name = selectedExtract?.extractName ? selectedExtract?.extractName : emptyValue;
  const description = selectedExtract?.description ? selectedExtract?.description : emptyValue;

  return (
    <FormSection className="ebt-extract-detail">
      <FormElement
        fieldId="name"
        labelText="Name">
        <label
          id="name"
          htmlFor="name"
          className="ebt-extract-detail__value">
          {name}
        </label>
      </FormElement>
      <FormElement
        fieldId="description"
        labelText="Description">
        <p
          id="description"
          className="ebt-extract-detail__value">
          {description}
        </p>
      </FormElement>
    </FormSection>
  );
};

export default ExtractViewPage;
